import React from 'react'
import { Button } from "@progress/kendo-react-buttons";
import { Badge, BadgeContainer } from '@progress/kendo-react-indicators';
import { UserApi } from '../../redux/api/UserApi';
import { Api } from '../../redux/api/BaseApi';
import { ClientApi } from '../../redux/api/ClientApi';

const FilterButton = (props: FilterButtonProps) => {
    const { data: clientTypeFilters } = UserApi.useGetClientTypeFiltersQuery();
    const badgeCount = clientTypeFilters?.filter(c => c.Checked).length
    const { data: userProfile } = Api.useGetUserProfileQuery();
    const disabled = userProfile?.Features.Client_Type_Filter_Disabled;
    const { data: clientTypes } = ClientApi.useGetClientTypesQuery()
    const myClientTypeIds = clientTypeFilters?.map(my => my.Company_Type_Id)
    const title = myClientTypeIds?.length === 0 ? `${props.clientTypePhrase} type filters: None` : `${props.clientTypePhrase} Types: ${clientTypes?.filter(ct => myClientTypeIds?.indexOf(ct.ID) > -1).map(ct => ct.Company_Type_Name).join(', ')}`
    return (
        <BadgeContainer>
            <Button type="button" icon="filter" onClick={props.onClick} formNoValidate={true} title={title} />
            {badgeCount > 0 && <Badge className='ml-1' size='small' align={{ horizontal: "start", vertical: "top" }}><span>{badgeCount}</span></Badge>}
        </BadgeContainer>
    )
}

type FilterButtonProps = {
    clientTypePhrase: string
    onClick: () => void
}
export default FilterButton